import { render, staticRenderFns } from "./PiecingTogetherTopBarIcon.vue?vue&type=template&id=4e0281ca&"
import script from "./PiecingTogetherTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./PiecingTogetherTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports